import React from "react";
import { ShareCardDialog, paintBase, paintBalls, paintFooter, GOLD, PARCH } from "./ShareCardDialog";

export function ShareResult({ row, open, onOpenChange }) {
  const last = row?.last;
  if (!last) return null;
  const site = window.location.host;
  const n = last.matches;
  const headline = n >= 3 ? `hit ${n} numbers.` : n > 0 ? `matched ${n} number${n === 1 ? "" : "s"}.` : "is still warming up.";
  const text = `${row.label} ${headline.replace(".", "")} on the ${last.date} Powerball draw${last.won ? ` — a ${last.prize} ticket` : ""}. See the live Oracle Scoreboard →`;

  const draw = (ctx) => {
    paintBase(ctx, 0.8, 0.3);
    ctx.font = "500 20px 'JetBrains Mono', monospace"; ctx.fillStyle = GOLD; ctx.textBaseline = "top"; ctx.letterSpacing = "5px";
    ctx.fillText("POWERBALL ORACLE · SCOREBOARD", 96, 120);
    ctx.letterSpacing = "0px";
    ctx.font = "300 80px Cormorant, Georgia, serif"; ctx.fillStyle = PARCH;
    ctx.fillText(row.label, 96, 158);
    ctx.font = "italic 400 80px Cormorant, Georgia, serif"; ctx.fillStyle = GOLD;
    ctx.fillText(headline, 96, 240);
    ctx.font = "500 16px 'JetBrains Mono', monospace"; ctx.letterSpacing = "4px"; ctx.fillStyle = "rgba(244,240,230,0.5)";
    ctx.fillText("THE ORACLE'S PICK", 96, 340);
    ctx.fillText("WINNING NUMBERS", 660, 340);
    ctx.letterSpacing = "0px";
    paintBalls(ctx, last.whites, last.powerball, { x: 96, y: 412, r: 36, gap: 14, hits: last.matched_list, pbHit: last.matched_powerball, dimMisses: true });
    if (last.draw) paintBalls(ctx, last.draw.whites, last.draw.powerball, { x: 660, y: 412, r: 36, gap: 14 });
    paintFooter(ctx, site, `${last.date.toUpperCase()} DRAW   ·   ${last.won ? `PRIZE TIER ${last.prize}` : "NO PRIZE TIER"}   ·   AVG ${row.avg_matches.toFixed(2)} HITS OVER ${row.picks} PICK${row.picks === 1 ? "" : "S"}`);
  };

  return (
    <ShareCardDialog
      open={open}
      onOpenChange={onOpenChange}
      title={<>Share the <span className="italic text-oracle">result</span></>}
      draw={draw}
      text={text}
      filename={`powerball-oracle-${row.strategy}-${last.date}.png`}
      testid="share-result"
    />
  );
}
